import express from 'express';
import jwt from "jsonwebtoken";
import { NextApiRequest, NextApiResponse } from 'next';

// https://nextjs.org/docs/api-routes/api-middlewares#connectexpress-middleware-support
export function runMiddleware(req: NextApiRequest, res: NextApiResponse, fn: any) {
    return new Promise((resolve, reject) => {
        fn(req, res, (result: any) => {
            if (result instanceof Error) {
                return reject(result);
            }

            return resolve(result);
        })
    })
}

function stripBearer(authHeader?: string) {
    if (authHeader?.startsWith("Bearer")) {
        return authHeader.slice("Bearer".length).trim();
    }
    return authHeader;
}

export function validateJwtIfExists(req: NextApiRequest, res: NextApiResponse, next: express.NextFunction) {
    const token = stripBearer(req.headers.authorization) || req.body.jwt || req.cookies.salsaJwt;
    if (!token) {
        next();
    } else {
        jwt.verify(token, process.env.JWT_SECRET!, (err: any, decoded: any) => {
            if (err) {
                res.status(401).json({});
                return;
            }
            if (req.method === 'GET') {
                req.body = {};
            }
            req.body.jwt = decoded;
            next();
        });
    }
}

export function validateJwt(req: NextApiRequest, res: NextApiResponse, next: express.NextFunction) {
    const token = stripBearer(req.headers.authorization) || req.body.jwt || req.cookies.salsaJwt;
    if (!token) {
        res.status(401).json({ error: "no token found" });
        return;
    }
    jwt.verify(token, process.env.JWT_SECRET!, (err: any, decoded: any) => {
        // TODO: switch the two lines below when we want to start rejecting non expirable JWTs
        // if (err || !decoded.exp) {
        if (err) {
            res.status(401).json({ error: "invalid token" });
            return;
        }
        if (req.method === 'GET' || req.method === 'DELETE') {
            req.body = {};
        }
        req.body.jwt = decoded;
        next();
    });
}
